<template>
  <div class="unregister-warning">
    <div class="unregister-subtitle">
      {{ $t('subscriptionCancel.cancelCard.warningSubtitle') }}
    </div>
    <div class="unregister-message">
      <p>
        {{ $t('subscriptionCancel.cancelCard.message.partOne') }}
      </p>
      <p>
        {{ $t('subscriptionCancel.cancelCard.message.partTwo') }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SubscriptionCancelCard'
})
</script>

<style lang="scss" scoped>
.unregister-warning {
  padding: 24px 0;
  min-height: 350px;

  .unregister-subtitle {
    color: red;
    font-size: 16px;
    margin-bottom: 16px;
  }

  .unregister-message {
    p {
      font-size: 14px;
      opacity: 0.86;
    }
  }
}
</style>
